import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AWSService } from 'src/app/shared/services/aws.service';
import { ApiVersions } from 'src/app/shared/services/api-version';

@Injectable({
  providedIn: 'root'
})
export class PortalAwsService extends AWSService {
  constructor() {
    super();
  }
  getUserObjectUrl(entityId: string, key: string): Observable<any> {
    let encodedKey = encodeURIComponent(key);
    return this.get(
      `portal/profile/custom-fields/custom-document/signed-url?key=${encodedKey}`,
      true,
      ApiVersions.unversioned
    );
  }

  deleteFromS3(
    entityId: string,
    filePath: string,
    isTeamDocument: boolean = false
  ): Observable<any> {
    return this.delete(
      `portal/profile/custom-fields/custom-document?key=${encodeURIComponent(filePath)}`,
      null,
      ApiVersions.unversioned,
      true
    );
  }
}
